var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('places-autocomplete',{attrs:{"options":_vm.options,"value":_vm.value,"disabled":_vm.disabled},on:{"selected":_vm.onPlaceSelected}})
}
var staticRenderFns = []

export { render, staticRenderFns }